import React from "react";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import { Save, Edit } from "@material-ui/icons";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import Cargando from "../../../../components/Generales/ModalCargando";
import Globales from "utils/Globales";
import withStyles from "@material-ui/core/styles/withStyles";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.jsx";

class CostoEnvioExcedente extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			CostoEnvioExcedente: 0,
			errorCostoEnvioExcedente: false,
			disable: true,
			mensaje: "",
			colorNotificacion: "success",
			MostrarModal: false,
			br: false,
		};
		this.obtenerCostoEnvioExcedente = this.obtenerCostoEnvioExcedente.bind(
			this
		);
		this.registrarCostoEnvioExcedente = this.registrarCostoEnvioExcedente.bind(
			this
		);
		this.editarCostoEnvioExcedente = this.editarCostoEnvioExcedente.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	componentDidMount() {
		this.obtenerCostoEnvioExcedente();
	}

	obtenerCostoEnvioExcedente() {
		fetch(Globales.Url + "admin/config/shipping/excess-cost", {
			method: "GET",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				Authorization: Globales.token,
			},
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.success && data.data) {
					this.setState({
						CostoEnvioExcedente: data.data.costoEnvioExcedente || 0,
					});
				} else {
					// Si no existe configuración (404) o hay error, inicializar en 0
					this.setState({ CostoEnvioExcedente: 0 });
				}
			})
			.catch((err) => {
				console.error("Error al obtener costo de envío excedente:", err);
				this.setState({ CostoEnvioExcedente: 0 });
			});
	}

	registrarCostoEnvioExcedente() {
		// Validar que sea un número válido
		const costo = parseFloat(this.state.CostoEnvioExcedente);

		if (this.state.CostoEnvioExcedente === "" || isNaN(costo) || costo < 0) {
			this.setState({
				mensaje: "El costo de envío debe ser un número mayor o igual a 0",
				errorCostoEnvioExcedente: true,
				colorNotificacion: "danger",
			});
			this.showNotification();
			return;
		}

		this.setState({
			MostrarModal: true,
			disable: true,
		});

		fetch(Globales.Url + "admin/config/shipping/excess-cost", {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				Authorization: Globales.token,
			},
			body: JSON.stringify({
				costoEnvioExcedente: costo,
			}),
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					this.setState({
						colorNotificacion: "success",
						errorCostoEnvioExcedente: false,
						disable: true,
						MostrarModal: false,
						mensaje: data.message || "Costo de envío guardado correctamente",
						CostoEnvioExcedente:
							data.data && data.data.costoEnvioExcedente
								? data.data.costoEnvioExcedente
								: costo,
					});
					this.showNotification();
				} else {
					this.setState({
						colorNotificacion: "danger",
						errorCostoEnvioExcedente: true,
						disable: false,
						MostrarModal: false,
						mensaje: data.message || "Error al guardar el costo de envío",
					});
					this.showNotification();
				}
			})
			.catch((err) => {
				console.error("Error al guardar costo de envío excedente:", err);
				this.setState({
					colorNotificacion: "danger",
					errorCostoEnvioExcedente: true,
					disable: false,
					MostrarModal: false,
					mensaje:
						"Error al guardar el costo de envío. Por favor, intente nuevamente.",
				});
				this.showNotification();
			});
	}

	editarCostoEnvioExcedente() {
		this.setState({ disable: !this.state.disable });
		this.obtenerCostoEnvioExcedente();
	}

	handleChange(e) {
		const { name, value } = e.target;
		// Validar que sea un número positivo
		if (name === "CostoEnvioExcedente") {
			const numericValue = parseFloat(value);
			if (!isNaN(numericValue) && numericValue >= 0) {
				this.setState({
					[name]: numericValue,
					errorCostoEnvioExcedente: false,
				});
			} else if (value === "" || value === "0") {
				this.setState({
					[name]: value,
					errorCostoEnvioExcedente: false,
				});
			}
		} else {
			this.setState({
				[name]: value,
			});
		}
	}

	showNotification() {
		var x = [];
		this.setState({ br: true });
		this.setState(x);
		this.alertTimeout = setTimeout(
			function() {
				this.setState({ br: false });
				this.setState(x);
			}.bind(this),
			4000
		);
	}

	componentWillUnmount() {
		if (this.alertTimeout) {
			clearTimeout(this.alertTimeout);
		}
	}

	render() {
		const { classes } = this.props;
		return (
			<GridItem xs={12} sm={12} md={12}>
				<Card>
					<CardHeader color="info">
						<h4 className={classes.cardTitleWhite}>
							Costo envío fijo para excedente
						</h4>
					</CardHeader>
					<CardBody>
						<div style={{ alignContent: "center", textAlign: "center" }}>
							<p
								style={{
									fontSize: "14px",
									color: "#666",
									marginBottom: "20px",
									fontStyle: "italic",
								}}
							>
								Este costo se le aplicará al carrito del usuario en caso de que
								el sistema detecte que no hay cajas disponibles para su compra
							</p>

							<CustomInput
								labelText="Costo de envío excedente"
								formControlProps={{
									fullWidth: true,
								}}
								inputProps={{
									disabled: this.state.disable,
									onChange: this.handleChange,
									value: this.state.CostoEnvioExcedente,
									name: "CostoEnvioExcedente",
									id: "CostoEnvioExcedente",
									type: "number",
									min: "0",
									step: "0.01",
									error: this.state.errorCostoEnvioExcedente,
								}}
							/>
						</div>

						<div className={classes.space50} />
						<div>
							<GridItem>
								<Button
									tabIndex="0"
									disabled={this.state.disable}
									color="success"
									type="submit"
									className="pull-right"
									onClick={this.registrarCostoEnvioExcedente}
								>
									<Save />
									Guardar
								</Button>
								<Button
									color="warning"
									type="submit"
									className="pull-right"
									onClick={this.editarCostoEnvioExcedente}
								>
									<Edit />
									{this.state.disable === true ? "Editar" : "Cancelar"}
								</Button>
							</GridItem>
						</div>
					</CardBody>
				</Card>

				<div id="">
					<Snackbar
						place="tr"
						color={this.state.colorNotificacion}
						message={this.state.mensaje}
						open={this.state.br}
						closeNotification={() => this.setState({ br: false })}
						close
					/>
				</div>

				<Cargando show={this.state.MostrarModal} Cuerpo="Cargando" />
			</GridItem>
		);
	}
}

export default withStyles(basicsStyle)(CostoEnvioExcedente);
